import { IState, PayFrequencyValues, Output } from '../types';
import { MutationTree } from 'vuex';

export default {
  updateAge(state, age: number) {
    state.ui.hasChangedAge = true;
    state.inputs.age = +age;
  },
  updateIncome(state, income: number) {
    state.ui.hasChangedIncome = true;
    state.inputs.income = +income;
  },
  updatePayFrequency(state, payFrequency: PayFrequencyValues) {
    state.inputs.payFrequency = payFrequency;
  },
  updateContributionRate(state, contributionRate: number) {
    state.inputs.contributionRate = +contributionRate;
  },
  pushVisibleRate(state, output?: Output) {
    if (output) {
      const { rate } = output.employee;

      if (state.ui.visibleRates.indexOf(rate) === -1) {
        state.ui.visibleRates.push(rate);
      }
    }
  },
} as MutationTree<IState>;
